import { mapActions, mapState, mapGetters } from "vuex"
import * as filestack from "filestack-js"
import axios from "axios"
import { clone } from "lodash";
import * as sizeValidator from "@/helpers/sizeValidator.js"
import MessageModal from "@/components/global/MessageModal";
import { apiKey } from "@/helpers/filestack.config";

export const uploadFilestack = {
  computed: {
    ...mapGetters(['computedOptions']),
    ...mapState(["uploadedPhotos", "allOptionGroups", "optionGroups", "selectedSize", "enableLowQualityImage"]),
  },
  components: {
    MessageModal,
  },
  data() {
    return {
      filestackOptions: {
        maxFiles: 1,
        uploadInBackground: false,
        disableTransformer: true,
        startUploadingWhenMaxFilesReached: true,
        fromSources: [
          "local_file_system",
          "instagram",
          "flickr",
          "dropbox",
          "picasa", //Google Photos
          "googledrive",
          "gmail",
          "onedrive",
          "clouddrive",
          "box",
        ], //onOpen: () => console.log("picker opened"),
        onUploadDone: res => {
          if (res.filesUploaded.length > 0 && res.filesFailed.length === 0) {
            this.handleResults(res);
          } else if (
            res.filesUploaded.length === 0 &&
            res.filesFailed.length === 0
          ) {
            console.error(
              "Error: 0 files uploaded but 0 files failed. This is a problem.",
              res
            );
          } else {
            console.error("Error: File(s) failed to upload.", res);
          }
        },
      },
      result: null,
      rowRes: false
    }
  },
  methods: {
    ...mapActions(["add", "set", "remove", "resetSelectedOption", "setSelectedOptions"]),
    openImagePicker(maxFiles) {
      this.set({ var: "enableLowQualityImage", val: true });
      this.filestackOptions.maxFiles = maxFiles;
      const filestackClient = filestack.init(apiKey);
      filestackClient.picker(this.filestackOptions).open();
    },
    handleResults(result) {
      this.result = clone(result);
      this.saveUploadToState(result);
    },
    saveUploadToState(result) {
      let imageUrl = result.filesUploaded[0].url;
      this.getMetadataForImage(imageUrl).then(response => {
        let metadata = response.data;
        // If there are no size option groups, skip the size check
        let options = null;
        let noSizes = false;
        if (this.computedOptions.some(option => option.isSize)) {
          options = sizeValidator.validateSizesForImageDimensions(
            metadata,
            this.computedOptions,
            this.enableLowQualityImage
          );
        } else {
          noSizes = true;
        }
        if (noSizes || this.hasValidSize(options)) {
          let image = {
            imageUrl: imageUrl,
            originalImageUrl: imageUrl,
            height: metadata.height,
            width: metadata.width,
          };
          if (this.hasImageAtIndex(0)) {
            this.removeImage(0);
          }
          this.add({ var: "uploadedPhotos", val: image });
          this.selectImage(this.uploadedPhotos.length - 1); //select the last image uploaded
          if (!this.allSizeValid(options)) {
            if (!this.allSizeValid(options) && options.length === 1) {
              this.setSelectedOptions({
                var: options[0].groupCode,
                val: {
                  ...options[0],
                  selected: true,
                }
              })
            }
            if (!this.rowRes) {
              this.rowRes = true
              this.$modal.show("size-warning-modal");
            }
          }
        }
        else {
          this.$modal.show("size-warning-modal");
        }
      })
    },
    selectImage(index) {
      if (this.hasImageAtIndex(index)) {
        let image = clone(this.uploadedPhotos[index]);
        this.set({ var: "selectedPhoto", val: image });
        let options = sizeValidator.validateSizesForImageDimensions(
          { height: image.height, width: image.width },
          this.computedOptions,
          this.enableLowQualityImage
        );
        this.validateSizeOptions(options);
      }
      else if (index == null) {
        this.set({ var: "selectedPhoto", val: null });
      }
      else {
        this.openImagePicker(this.maxFiles);
      }
    },
    validateSizeOptions(options) {
      if (this.hasValidSize(options)) {
        let sizeOptionGroup_All = sizeValidator.getSizeOptionGroup(
          this.computedOptions
        );
        if (sizeOptionGroup_All) {
          sizeOptionGroup_All.options = options; //save validated options
        }
        let sizeOptionGroup_Filtered = sizeValidator.getSizeOptionGroup(
          this.optionGroups
        );
        if (sizeOptionGroup_Filtered) {
          sizeOptionGroup_Filtered.options = options; //save validated options
        }
        // If currently selected size is no longer valid for new photo, deselect it
        if (this.selectedSize) {
          let currentSize = options.find(
            option => option.optionCode == this.selectedSize.optionCode
          );
          if (!currentSize.isValid) {
            this.resetSelectedOption(this.selectedSize);
          }
        }
      }
    },
    removeImage(index) {
      this.remove({
        var: "uploadedPhotos",
        val: index,
      });
      if (this.hasImageAtIndex(0)) {
        this.selectImage(0);
      } else {
        this.selectImage(null);
      }
    },
    hasValidSize(sizeOptions) {
      return sizeOptions.some(size => size.isValid);
    },
    allSizeValid(sizeOptions) {
      const hasLowRes = sizeOptions.some(size => !size.isValid) || sizeOptions.some(size => typeof size.isLowRes !== 'undefined' && size.isLowRes)
      return !hasLowRes
    },
    getMetadataForImage(imageUrl) {
      return axios.get(imageUrl + "/metadata?height=true&width=true");
    },
    hasImageAtIndex(index) {
      return this.uploadedPhotos[index];
    },
    actionEnableLowQualityImage () {
      this.set({ var: "enableLowQualityImage", val: true });
      this.saveUploadToState(this.result)
    }
  }
}
